@if (form) {
    <div class="w-full max-w-5xl p-8">
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
            <h2>{{ 'label_technical_support_requests' | translate }}</h2>
        </div>
        <span class="separator-line block mb-[px]"></span>
        <br />
        <mat-tab-group
            class="sm:px-2 hjalp-tab-group fade-in-left"
            [animationDuration]="'0'"
            [(selectedIndex)]="selectedPanelIndex"
            (selectedTabChange)="tabChanged($event)"
        >
            <mat-tab [label]="'label_register_request' | translate">
                <form [formGroup]="form" #profileInNgForm="ngForm">
                    <div class="grid sm:grid-cols-4 gap-6 w-full">
                        <ng-container>
                            <div class="col-span-4">
                                <mat-form-field class="w-full">
                                    <mat-label>{{ 'label_type' | translate }}</mat-label>
                                    <mat-select
                                        (selectionChange)="onChangeAssistType($event.value)"
                                        [formControlName]="'assistTypesConfigId'"
                                        placeholder="Tegund"
                                    >
                                        @for (type of assistTypes; track type) {
                                            <mat-option [value]="type.value">
                                                {{ type.viewValue }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-hint class="float-left">{{ selectedAssistType?.description }}</mat-hint>
                                </mat-form-field>
                            </div>
                            @if (showAlert) {
                                <div class="col-span-4">
                                    <ng-container>
                                        <div id="errorAlert">
                                            <div class="center-div alert-content">
                                                <div id="bodyAlert" class="fade-in-left c-alert">
                                                    <mat-icon
                                                        id="c-close"
                                                        class="white white-hover icon-size-5 hover:cursor-pointer"
                                                        (click)="closeAlert()"
                                                        svgIcon="heroicons_outline:x"
                                                    ></mat-icon>
                                                    <fuse-alert [type]="'warning'">
                                                        <span fuseAlertTitle>{{ alertTitle }}</span>
                                                        <span [innerHTML]="alertHTML"></span>
                                                        <span class="separator-line mt-1 mb-1 float-left w-100"></span>
                                                        <span class="text-sm float-left w-100">{{ alertFooter }}</span>
                                                    </fuse-alert>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            }
                            <div class="col-span-4">
                                <span
                                    [ngClass]="{
                                        'mt-1': showAlert,
                                        'mt-0': !showAlert,
                                    }"
                                    class="separator-line mb-1 float-left w-100"
                                ></span>
                            </div>
                            <div class="col-span-4">
                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                    <mat-label>{{ 'label_title' | translate }}</mat-label>
                                    <input [formControlName]="'title'" matInput />
                                </mat-form-field>
                            </div>
                            <div class="col-span-4">
                                <div
                                    class="text-[14px] font-medium mb-1"
                                    [ngClass]="{
                                        'validation-error-color': form?.get('description')?.hasError('required') && submitted,
                                        'opacity-60': !formEnabled,
                                    }"
                                >
                                    {{ 'label_description' | translate }}
                                </div>
                                <ckeditor
                                    [disabled]="form?.get('description')?.disabled"
                                    [editor]="descriptionEditor"
                                    [(ngModel)]="descriptionTextHTML"
                                    name="descriptionTextHTML"
                                    [ngModelOptions]="{ standalone: true }"
                                    [config]="editorConfig"
                                    (ready)="onEditorReady($event)"
                                    (change)="descriptionOnChange($event)"
                                    id="editorDescription"
                                ></ckeditor>
                            </div>
                            <div class="col-span-4">
                                <ngx-dropzone
                                    class="custom-dropzone"
                                    class="justify-center"
                                    (change)="onSelect($event)"
                                    [disabled]="this.form.disabled"
                                >
                                    <ngx-dropzone-label>
                                        <div>
                                            <h2>
                                                {{ 'info_add_attachment' | translate }}
                                            </h2>
                                            <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                                        </div>
                                    </ngx-dropzone-label>
                                    @for (f of files; track f) {
                                        <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)">
                                            <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                        </ngx-dropzone-preview>
                                    }
                                </ngx-dropzone>
                            </div>
                        </ng-container>
                    </div>
                    <div class="flex items-center justify-end mt-[20px]">
                        @if (form.dirty) {
                            <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                                {{ 'label_cancel' | translate }}
                            </button>
                        }
                        <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                            @if (formEnabled) {
                                <span>
                                    {{ 'label_register_request' | translate }}
                                </span>
                            }
                            @if (!formEnabled) {
                                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                            }
                        </button>
                    </div>
                </form>
            </mat-tab>
            <mat-tab [label]="'label_my_request' | translatePlural">
                <div>
                    <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-4 px-6 md:px-8 border-b">
                        <!-- Main actions -->
                        <div class="flex items-center">
                            <!-- Search -->
                            <div class="flex-auto">
                                <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                    <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                                    <input
                                        matInput
                                        [placeholder]="'label_search' | translate"
                                        (keyup)="searchFilter($event.target.value)"
                                    />
                                </mat-form-field>
                                @if (loaded) {
                                    <div class="mr-0.5 float-right mt-0.5 font-medium text-secondary">
                                        {{
                                            'info_requests_found_count'
                                                | translate
                                                    : {
                                                          count: displayedData.filteredData.length,
                                                      }
                                        }}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData"
                    class="w-[100%]">
                    <ng-container matColumnDef="workItemId">
                        <th mat-sort-header="workItemId" mat-header-cell *matHeaderCellDef>
                            {{ 'label_audkenni' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> <a class="c-link" target="_blank"
                                [matTooltip]="'label_open_request' | translate"
                                href="{{element.url}}">{{element.workItemId}}</a> </td>
                    </ng-container>
                    <ng-container matColumnDef="title">
                        <th mat-sort-header="title" mat-header-cell *matHeaderCellDef>
                            {{ 'label_title' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> <a class="c-link" target="_blank"
                                [matTooltip]="'label_open_request' | translate"
                                href="{{element.url}}">{{element.title}}</a> </td>
                    </ng-container>
                    <ng-container matColumnDef="timeStamp">
                        <th mat-sort-header="timeStamp" mat-header-cell *matHeaderCellDef>
                            {{ 'label_date' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> <span
                                [matTooltip]="'label_registered_at' | translate">{{formatDate(element.timeStamp)}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="state">
                        <th mat-sort-header="state" mat-header-cell *matHeaderCellDef>
                            {{ 'label_status' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"><span
                                class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase"
                                [ngClass]="badgeClass(element.state)">
                                <span class="leading-relaxed whitespace-nowrap">{{ 'label_' + (toAzureDevOpsStateKey(element.state)) | translate }}</span>
                            </span></td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="orgRequestsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: orgRequestsColumns;"></tr>
                    <tr class="mat-row" [ngClass]="{'h-0' : isLoading}" *matNoDataRow>
                        @if (!isLoading && initalFetchComplete) {
                            <div class="flex items-center justify-between">
                                <span>
                                    <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">
                                        {{ 'info_requests_found_count' | translate: { count: 0 } }}
                                    </div>
                                </span>
                            </div>
                        }
                    </tr>
                </table>
                @if (isLoading) {
                    <div class="flex justify-center items-center gap-2 pt-4 pb-4 bg-white">
                        <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'">
                        </mat-progress-spinner>
                        Sæki beiðnir
                    </div>
                }
                @if (!isLastPage) {
                    <div #sentinel class="h-1"></div>
                }
            </mat-tab>
        </mat-tab-group>
    </div>
}
